<div
  [ngClass]="
    'search-widget-field-group station-picker ' + routeSelectorBorderRadius
  "
  id="route-selector"
  [ngClass]="{
    disabled: isDisabled,
    'search-widget-field-group station-picker': true,
    'station-picker--rounded-top-only': isDateRangePickerEnabled,
  }"
>
  <form
    *ngIf="stationsFormGroup"
    [formGroup]="stationsFormGroup"
    autocomplete="off"
  >
    <div class="row">
      <div class="col-12 px-2 station-column" (click)="$event.preventDefault(); openStationPickerForOriginInput()">
        <div class="origin text-center py-2 d-flex" [ngClass]="{'promo-code-input-background': isPromoCodeLanding}">
          <i
            class="icon fa-kit fa-outbound d-flex align-items-center justify-content-center"
          ></i>
          <label
            *ngIf="!originStationNameControl.value"
            class="col-auto"
            for="{{ index }}-originStationName"
          >
            <span class="fw-normal">{{ copy?.fromCopy ?? fromCopy }}</span>
          </label>
          <div class="station-inputs-wrapper">
            <input
              #origin
              type="text"
              id="{{ index }}-originStationName"
              name="originStationName"
              data-qa="originStationName"
              formControlName="originStationName"
              placeholder=""
              [ngClass]="{
                disabled: isDisabled
              }"
              class="station-name"
              [attr.disabled]="isDisabled ? true : null"
              readonly
            />
            <input
              type="hidden"
              name="originStationCode"
              formControlName="originStationCode"
              value=""
            />
            <div
              id="{{ index }}-originStationList"
              class="origin station-box selection-picker-box"
              [ngStyle]="{
                display: originPickerVisible ? 'none' : 'none'
              }"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-12 city-swap">
        <button
          id="btnSwap"
          (click)="onSwapClick()"
          class="btn-circle swap"
          aria-label="swap"
          tabindex="-1"
          [attr.disabled]="isDisabled ? true : null"
          [ngClass]="{
            disabled: isDisabled
          }"
        >
          <i class="fs-5 fa-regular fa-arrow-up-arrow-down"></i>
          <span class="visually-hidden">swap</span>
        </button>
      </div>
      <div
        class="col-12 px-2 station-column"
        (click)="$event.preventDefault(); openStationPickerForDestinationInput()"
      >
      <div class="destination py-2 d-flex" [ngClass]="{'promo-code-input-background': isPromoCodeLanding}">
        <i
            class="icon fa-kit fa-destination d-flex align-items-center justify-content-center"
          ></i>
          <label
            *ngIf="!destinationStationNameControl.value"
            class="col-auto"
            for="{{ index }}-destinationStationName"
          >
            <span class="fw-normal">{{ copy?.toCopy ?? fromCopy }}</span>
          </label>
          <div class="station-inputs-wrapper">
            <input
              #destination
              type="text"
              id="{{ index }}-destinationStationName"
              name="destinationStationName"
              data-qa="destinationStationName"
              formControlName="destinationStationName"
              placeholder=""
              [ngClass]="{
                disabled: isDisabled
              }"
              class="station-name"
              [attr.disabled]="isDisabled ? true : null"
              readonly
            />
            <input
              type="hidden"
              name="destinationStationCode"
              formControlName="destinationStationCode"
              value=""
            />
            <div
              id="{{ index }}-destinationStationList"
              class="destination station-box selection-picker-box"
              [ngStyle]="{
                display: destinationPickerVisible ? 'none' : 'none'
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<ng-template #dohopOriginList>
  <ul
    *ngIf="norseStations?.length ?? 0 > 0"
    class="station-list"
    data-testid="originStationList"
  >
    <li
      *ngFor="let station of norseStations; index as i"
      (mousedown)="onOriginStationSelect(station)"
      id="{{ 'norseOriginStation' + i }}"
      class="norse-station"
    >
      <div>
        {{
          station?.fullName + " (" + getMacOverride(station?.stationCode) + ")"
        }}
      </div>
    </li>
    <li
      *ngIf="dohopFeatureStations && dohopFeatureStations.length > 0"
      class="custom-item"
    >
      {{ copy?.connectingText }}
    </li>
    <li
      *ngFor="let station of dohopFeatureStations; index as i"
      (mousedown)="onOriginStationSelect(station)"
      id="{{ 'dohopOriginStation' + i }}"
    >
      <div>
        {{
          station?.fullName + " (" + getMacOverride(station?.stationCode) + ")"
        }}
      </div>
    </li>
    <li
      *ngIf="dohopFeatureStations && dohopFeatureStations.length > 0"
      class="custom-item-footer"
    >
      {{ copy?.connectingMoreText }}
    </li>
  </ul>
</ng-template>
<ng-template #dohopDestinationList>
  <ul
    *ngIf="norseStations?.length ?? 0 > 0"
    class="station-list"
    data-testid="destinationStationList"
  >
    <li
      *ngFor="let station of norseStations; index as i"
      (mousedown)="onDestinationStationSelect(station)"
      id="{{ 'norseDestinationStation' + i }}"
      class="norse-station"
    >
      <div>
        {{
          station?.fullName + " (" + getMacOverride(station?.stationCode) + ")"
        }}
      </div>
    </li>
    <li
      *ngIf="dohopFeatureStations && dohopFeatureStations.length > 0"
      class="custom-item"
    >
      {{ copy?.connectingText }}
    </li>
    <li
      *ngFor="let station of dohopFeatureStations; index as i"
      (mousedown)="onDestinationStationSelect(station)"
      id="{{ 'dohopDestinationStation' + i }}"
    >
      <div>
        {{
          station?.fullName + " (" + getMacOverride(station?.stationCode) + ")"
        }}
      </div>
    </li>
    <li
      *ngIf="dohopFeatureStations && dohopFeatureStations.length > 0"
      class="custom-item-footer"
    >
      {{ copy?.connectingMoreText }}
    </li>
  </ul>
</ng-template>
